module.exports = __webpack_public_path__ + "img/icon_map_199_off_100.4ff317d8.png";